// extracted by mini-css-extract-plugin
module.exports = {"delivery-img":"styles_delivery-img__2iuPp","deliveryImg":"styles_delivery-img__2iuPp"};